import AppToaster from "./components/common/AppToaster";
import "./App.css";
import AppState from "./context/AppState";
import Router from "./routes/Router";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../src/assets/fonts/font.css";
import { useContext } from "react";
import AppContext from "./context/AppContext";
import useAutoUpdate from "./hook/useAutoUpdate";
import { initClientIdentity } from "./utils/clientIdentity";
import { getUserInfoAPI } from "./service/User";

function App() {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current route
  // useAutoUpdate()
  const context = useContext(AppContext);
  const { setRcOrgName, setRcOrgId, setPriority, setActive, setAreaCode, setSelectedUserId, setAccountNo, theme, setWorkflowId, setSelectedOption, setRcWorkflowId, setRcWorkflowName } = context;

  const parseJwt = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  };
  const checkTokenExpiry = () => {
    const accessToken = Cookies.get('accessToken');
    if (accessToken) {
      const decodedToken = parseJwt(accessToken);
      const isExpired = new Date() > new Date(decodedToken.exp * 1000);
      return isExpired;
    }
    return true;
  };

  const clearAuthAndSelectionData = () => {
    const cookies = Cookies.get();
    for (const cookie in cookies) {
      Cookies.remove(cookie);
    }
    sessionStorage.clear();
    localStorage.removeItem("userDetails");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("activeTab");
    localStorage.removeItem("selectedOrgName");
    localStorage.removeItem("selectedOrgId");
    localStorage.removeItem("userPermissions");

    localStorage.removeItem("selectedFields");
    localStorage.removeItem("FCMToken");
    localStorage.removeItem("RcselectedOrgId");
    localStorage.removeItem("RcselectedOrgName");
    localStorage.removeItem("departmentId");
    localStorage.removeItem("projectId");
    localStorage.removeItem("userManageTableView");
    setRcOrgName("");
    setRcOrgId("");
    setSelectedOption("");
    setWorkflowId("");
    setRcWorkflowId("");
    setRcWorkflowName("");
    window.localStorage.removeItem("isLoggedIn");
  };

  useEffect(() => {
    initClientIdentity();
    const refreshUserDetails = async () => {
      const accessToken = Cookies.get("accessToken");
      const userId = Cookies.get("userId");
      if (!accessToken || !userId) return;
      try {
        const response = await getUserInfoAPI(userId);
        const freshUser = response?.data?.body?.value;
        if (freshUser && typeof freshUser === "object") {
          let currentStored = {};
          try {
            currentStored = JSON.parse(localStorage.getItem("userDetails") || "{}");
          } catch {
            currentStored = {};
          }
          const merged = { ...currentStored, ...freshUser };
          localStorage.setItem("userDetails", JSON.stringify(merged));
          sessionStorage.setItem("userDetails", JSON.stringify(merged));
        }
      } catch (err) {
        // non-blocking
      }
    };
    refreshUserDetails();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (checkTokenExpiry()) {
        clearAuthAndSelectionData();
        navigate('/');
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [navigate]);



  useEffect(() => {
    const NoToken = () => {
      const accessToken = Cookies.get('accessToken');
      if (!accessToken) {
        window.localStorage.removeItem("isLoggedIn");
        navigate("/")
      }
    }
    NoToken();
  }, [navigate]);

  useEffect(() => {
    if (!location.pathname.includes("task")) {
      Cookies.remove("mapListFilters")
      sessionStorage.removeItem("taskSearchValue")
      sessionStorage.removeItem("from_Date")
      sessionStorage.removeItem("to_Date")

      setPriority("Priority");
      setActive("Status");
      setSelectedUserId("")
      setAreaCode("")
      setAccountNo("");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope);
      })
      .catch((err) => {
        console.error("Serivice Worker registration failed:", err);
      });
  }, []);

  const [user, setUser] = useState(null);

  return (
    <>
      {/* <AppState> */}
      <Router user={user} />
      <AppToaster />
      {/* </AppState> */}
    </>
  );
}

export default App;
